import React from 'react';
import { CalculationResponse } from '../Interfaces';
import { formatCurrency } from '../Helpers/formatters';

interface CalculationResultsProps {
  results: CalculationResponse;
  inflationRate: number;
}

const realValue = (nominal: number, years: number, inflationRate: number) =>
  nominal / Math.pow(1 + inflationRate / 100, years);

export const CalculationResults: React.FC<CalculationResultsProps> = ({ results, inflationRate }) => {
  const pensionReal = realValue(results.pension.finalBalance, results.pension.years, inflationRate);
  const indexReal = realValue(results.index.finalBalance, results.index.years, inflationRate);
  const differenceReal = pensionReal - indexReal;

  return (
    <div className="key-results">
      <div className="result-card">
        <h2>💼 Pension</h2>
        <div className="amount">{formatCurrency(results.pension.finalBalance)}</div>
        <div className="real-value">≈ {formatCurrency(pensionReal)} in today's money</div>
        <p>
          Over {results.pension.years} years<br />
          Including {formatCurrency(results.pension.totalEmployerContrib || 0)} employer contributions
        </p>
      </div>
      <div className="result-card">
        <h2>📈 Index Fund</h2>
        <div className="amount">{formatCurrency(results.index.finalBalance)}</div>
        <div className="real-value">≈ {formatCurrency(indexReal)} in today's money</div>
        <p>
          Over {results.index.years} years<br />
          After {formatCurrency(results.index.capitalGainsTax || 0)} tax on withdrawals
        </p>
      </div>
      <div className="result-card">
        <h2>📊 Difference</h2>
        <div
          className="amount"
          style={{ color: results.difference >= 0 ? '#27ae60' : '#e74c3c' }}
        >
          {results.difference >= 0 ? '+' : ''}{formatCurrency(results.difference)}
        </div>
        <div className="real-value">
          ≈ {differenceReal >= 0 ? '+' : ''}{formatCurrency(differenceReal)} in today's money
        </div>
        <p>{results.difference >= 0 ? 'Pension advantage' : 'Index fund advantage'}</p>
      </div>
      <div className="result-card">
        <h2>💰 Total Contributions</h2>
        <div className="amount">{formatCurrency(results.pension.totalEmployeeContrib || 0)}</div>
        <p>
          Pension: {formatCurrency(results.pension.totalEmployeeContrib || 0)}<br />
          Index: {formatCurrency(results.index.totalContributions || 0)}
        </p>
      </div>
    </div>
  );
};